import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useSobreavisoOutletContext } from 'pages/Sobreaviso.context'
import { useParams } from 'react-router-dom'
import { sobreaviso } from 'service/api'
import { toast } from 'sonner'

export default function ExcluirSobreaviso() {
    const { id } = useParams()
    const { data } = useSobreavisoOutletContext()
    const s = data?.find(item => item.id === Number(id))

    const { mutateAsync, isLoading } = sobreaviso.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!s) return null

    const handleSubmit = () =>
        mutateAsync(s.id, {
            onSuccess: () => {
                toast.success('Sobreaviso excluído com sucesso')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Sobreaviso']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={
                <>
                    Realmente deseja excluir o sobreaviso do horário{' '}
                    {s.horarioInicial} até {s.horarioFinal}?
                </>
            }
        />
    )
}
